// extracted by mini-css-extract-plugin
export default {"thumb":"byULtSTx","activeThumb":"WkeGCGGA","wrapper":"fGbHRvDC","wrapperLeft":"qX4i84_m","container":"Iy0STkHx","lastThumb":"bcox5TMy"};